import 'jquery.cookie';
import abTests from '@/js/common/Domain/Service/abTests';

import requestService from './request';

export default (tourCriteriaForTourRequest, callback) => {
    const options = {
        cache: false,
        data: {
            ...tourCriteriaForTourRequest,
            abTests: abTests.getTests(),
        },
        type: 'POST',
        url: `${window.appConfig.apiGatewayUrl}/frontend/hotelOffers/asyncSearch`,
    };

    return requestService(options, callback);
};